module.exports = __webpack_public_path__ + "static/media/tire-mounting-red.b78dace0.svg";